import './App.css';
import Header from '../../components/Header/Header'; 
import Footer from '../../components/Footer/Footer'; 
import Body from '../../components/Body/Body'; 

function App() {
  
  return (
    <>
        <Header />
        <Body />
        <Footer />
    </>
  );
}

export default App;
